import React from "react";
import { Button } from "react-materialize";
import Func from "utils/Func";
import { useNotify } from "context/NotifyContext";

export default function BtnSearch() {
  const { filters, storeFilters } = useNotify();

  let handleEvents = {
    OnClick: function (evt) {
      evt.preventDefault();
      storeFilters({
        ...filters,
        keyChange: Func.GetKeyRandom(),
      });
    },
  };

  return (
    <Button
      node="button"
      id="btn-search"
      style={{ float: "right", backgroundColor: "#1565c0" }}
      onClick={handleEvents.OnClick}
    >
      Search
    </Button>
  );
}
